var exports = {
  "y": "x31de4314--2cfff8--popup-link",
};

module.exports = exports;
